module.exports = __webpack_public_path__ + "img/nanwa2.eb37b2ab.png";